export const stepLabels = {
  1: {
    title: 'Select import format',
    subTitle: 'Select format',
  },
  2: { title: 'Import settings', subTitle: 'Import settings' },
  3: { title: 'File parsing settings', subTitle: 'Parsing settings' },
  4: { title: 'Upload file', subTitle: 'Select file and import' },
};

export const intercomDefaultMessage = 'Hi Toriut support team, I’m encountering the “Import validation required” message. Please assist further.';

export const formatOptions = [
  { value: 'csv', label: 'CSV', icon: 'Csv' },
  { value: 'json', label: 'JSON', icon: 'Json' },
  { value: 'xml', label: 'XML', icon: 'Xml' },
  { value: 'xlsx', label: 'XLSX', icon: 'Excel' },
];

export const importOptions = [
  { value: 'new', label: 'Import new products only', description: 'This option will ignore existing SKUs and will import new SKUs only' },
  { value: 'update', label: 'Update existing products', description: 'This option will update only existing SKUs and ignore new SKUs only.' },
  { value: 'both', label: 'New and update existing products', description: 'This option will update existing SKUs and will create new SKUs.' },
];

export const separatorOptions = [
  { value: ',', title: 'Comma (,)', _id: 'Comma' },
  { value: ';', title: 'Semicolon (;)', _id: 'Semicolon' },
  { value: ':', title: 'Colon (:)', _id: 'Colon' },
  { value: '\t', title: 'Tab (↹)', _id: 'Tab' },
];

export const delimiterOptions = [
  { value: '"', title: 'Double quote (")', _id: 'DoubleQuote' },
  { value: "'", title: "Single quote (')", _id: 'SingleQuote' },
  { value: '`', title: 'Back-tick (`)', _id: 'BackTick' },
  { value: '', title: 'None', _id: 'None' },
];

export const charsetOptions = [
  { value: 'utf-8', title: 'UTF-8', _id: 'UTF8' },
  { value: 'windows-1252', title: 'Windows-1252', _id: 'Windows1252' },
  { value: 'iso-8859-1', title: 'ISO-8859-1', _id: 'ISO88591' },
];
